import { StreemAPI } from '@streem/api';
import { recordArtifactDeleted, recordArtifactFulfilled, recordArtifactUpdated, } from '@streem/analytics';
import { BehaviorSubject, tap } from 'rxjs';
import { filter, shareReplay } from 'rxjs/operators';
import { Long, WallItem } from 'streem-sdk-protobuf';
import { logger } from '../../util/logger';
import { accumulateAndMapWallEvents, accumulateAndTransformWallEvents, filterByProperty, findInGroup, } from '../wall/utils';
import { artifactTimedDeletion } from '../../util/rx/artifact_timed_deletion';
import { lastCreatedAt } from '../../util/rx/last_created_at';
import { firstFromGroup } from '../../util/rx/first_from_group';
export class BookmarkController {
    constructor(config) {
        this.config = config;
        this.latestBookmarkTime = new Long(0);
        this.bookmarks = this.config.roomWall.itemsByType.pipe(findInGroup('artifact'), accumulateAndTransformWallEvents('artifact'), filterByProperty('artifactType', WallItem.ArtifactType.BOOKMARK), shareReplay(1));
        this._bookmarkToSelect = new BehaviorSubject(undefined);
        this.bookmarkToSelect = this._bookmarkToSelect.asObservable();
        // Pipe the latest bookmark into the bookmarkToSelect subject
        this.bookmarks
            .pipe(
        // Get the latest bookmark
        lastCreatedAt(), 
        // Only take newer bookmarks (as opposed to firing an older one after the latest bookmark is deleted)
        filter((b) => {
            return (!b ||
                (b?.bookmark?.timestamp?.seconds || new Long(0)) > this.latestBookmarkTime);
        }), 
        // Save latest date on this controller... I'm sure there's a more rx-y way of doing this... -SA
        tap((b) => {
            this.latestBookmarkTime =
                b?.bookmark?.timestamp?.seconds || this.latestBookmarkTime;
        }))
            .subscribe(this._bookmarkToSelect);
        this.callStartTime = this.config.roomWall.itemsByType.pipe(findInGroup('artifact'), accumulateAndMapWallEvents('artifact'), filterByProperty('artifactType', WallItem.ArtifactType.RECORDING), firstFromGroup());
    }
    clearBookmarkToSelect() {
        this._bookmarkToSelect.next(undefined);
    }
    /**
     * Adds a bookmark to the wall
     */
    addBookmark(bookmark) {
        const response = this.config.roomWall.addBookmark({
            artifactType: WallItem.ArtifactType.BOOKMARK,
            bookmark: bookmark,
            status: WallItem.Artifact.Status.FULFILLED,
        });
        recordArtifactFulfilled(response);
        logger.info(`added bookmark ${response} to wall`);
    }
    /**
     * Updates a bookmark on the wall
     */
    updateBookmark(bookmarkId, bookmark) {
        const response = this.config.roomWall.addBookmark({
            artifactType: WallItem.ArtifactType.BOOKMARK,
            bookmark: bookmark,
            status: WallItem.Artifact.Status.FULFILLED,
        }, bookmarkId);
        recordArtifactUpdated(response);
        logger.info(`updated bookmark ${response} to wall`);
    }
    /**
     * Deletes a bookmark with a REST endpoint and from the wall
     */
    async deleteBookmark(bookmarkId) {
        try {
            await StreemAPI.rooms.deleteBookmark(this.config.context.roomId.toString(), bookmarkId);
            await artifactTimedDeletion(bookmarkId, this.bookmarks);
            recordArtifactDeleted({
                artifactSid: bookmarkId,
                roomSid: this.config.context.roomId.toString(),
                bookmark: {},
            });
        }
        catch (e) {
            logger.error(`error deleting bookmark ${bookmarkId}`, e);
        }
    }
}
//# sourceMappingURL=bookmark_controller.js.map